import React, { useState } from 'react';
import { Stack, Typography } from '@worthy-npm/worthy-common-ui-components';
import { getShippingMethod, setShippingMethod } from '../../slices/schedulingSlice';
import { SchedulingType } from '../../types/scheduling';

import MethodSelection from './MethodSelection';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import WorthyAPI from '../../services/worthyAPI';
import { selectItemPublicId } from '../../slices/submitSlice';
import NextButton from './NextButton';

function MethodSelectionContent({ nextStep }: { nextStep: () => void }) {
  const dispatch = useAppDispatch();
  const itemPublicId = useAppSelector(selectItemPublicId);
  const shippingMethod = useAppSelector(getShippingMethod);
  const [value, setValue] = useState<SchedulingType>(shippingMethod);

  const handleNext = () => {
    if (value !== shippingMethod) {
      dispatch(setShippingMethod(value));
      WorthyAPI.logUserAction(`${value} radio button selected`, itemPublicId).catch((err) => {
        console.error(
          `Error logging ${value} radio button selected user action for item ${itemPublicId}`,
          err,
        );
      });
      WorthyAPI.sendShippingIntent(itemPublicId).catch((err) => {
        console.error(`Error sending shipping intent for item ${itemPublicId}`, err);
      });
    }
    nextStep();
  };
  return (
    <Stack gap={3} alignItems="center">
      <Stack gap={2}>
        <Typography variant="body1">Choose your preferred shipping option.</Typography>
        <MethodSelection method={value} setMethod={setValue} />
      </Stack>
      <NextButton onClick={handleNext} />
    </Stack>
  );
}

export default MethodSelectionContent;
